;(function (Wishlist, $) {
  var initialized = false;
  var pagePath = window.location.pathname;
  var isWishlistPage = pagePath.indexOf('/pages/wishlist') > -1;

  function normalizeWishlist(raw) {
    if (!Array.isArray(raw)) {
      return [];
    }

    return raw.filter(function (handle, index) {
      return !!handle && raw.indexOf(handle) === index;
    });
  }

  function getWishlist() {
    var raw = localStorage.getItem('user_wishlist');
    var parsed = [];

    if (raw) {
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        parsed = [];
      }
    }

    return normalizeWishlist(parsed);
  }

  function saveWishlist(wishlist) {
    var normalized = normalizeWishlist(wishlist);

    localStorage.setItem('user_wishlist', JSON.stringify(normalized));
    localStorage.setItem('user_wishlist_count', normalized.length);

    return normalized;
  }

  function updateCounters(count) {
    $('.wishlist-counter').text(count);
    $('.rb-dash-wishlist-count').text(count);
  }

  function syncButtons(scope) {
    var wishlist = getWishlist();
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.wishlist-btn').each(function () {
      var handle = $(this).attr('data-product-handle');
      $(this).toggleClass('is-active', wishlist.indexOf(handle) > -1);
    });
  }

  function updateWishlistPageState() {
    if (!isWishlistPage) {
      return;
    }

    var wishlist = getWishlist();
    var visibleCount = 0;

    $('.wishlist-tile-container').each(function () {
      var handle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(handle) === -1) {
        $(this).remove();
      } else {
        visibleCount += 1;
      }
    });

    $('.wishlist-loader').hide();

    if (visibleCount === 0) {
      $('.wishlist-grid').hide();
      $('.wishlist-grid-empty-list').addClass('is_visible').show();
    } else {
      $('.wishlist-grid').addClass('is_visible').show();
      $('.wishlist-grid-empty-list').removeClass('is_visible').hide();
    }
  }

  function toggleWishlist(handle) {
    var wishlist = getWishlist();
    var existingIndex = wishlist.indexOf(handle);
    var isRemoving = existingIndex > -1;

    if (isRemoving) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.push(handle);
    }

    wishlist = saveWishlist(wishlist);
    updateCounters(wishlist.length);
    syncButtons(document);

    return {
      isRemoving: isRemoving,
      count: wishlist.length
    };
  }

  function bindEvents() {
    $(document).on('click', '.wishlist-btn', function (event) {
      var handle = $(this).attr('data-product-handle');

      if (!handle) {
        return;
      }

      event.preventDefault();

      var result = toggleWishlist(handle);

      if (isWishlistPage && result.isRemoving) {
        $(this).closest('.wishlist-tile-container').remove();
        updateWishlistPageState();
      }
    });

    $(document).on('click', '#remove-done', function (event) {
      event.preventDefault();

      saveWishlist([]);
      updateCounters(0);
      syncButtons(document);

      if (isWishlistPage) {
        $('.wishlist-tile-container').remove();
        updateWishlistPageState();
      }
    });
  }

  Wishlist.init = function () {
    if (!initialized) {
      bindEvents();
      initialized = true;
    }

    var wishlist = saveWishlist(getWishlist());
    updateCounters(wishlist.length);
    syncButtons(document);
    updateWishlistPageState();
  };
}(window.Wishlist = window.Wishlist || {}, jQuery));
